import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConsumerLead, User } from '@usheru-hff/shared/domain';
import { EMAIL_PATTERN } from '@usheru-hff/shared/utils';
import { AuthService } from '@usheru-hff/authentication/domain';
import { TranslationsService } from '@usheru-hff/shared/utils-translation';
import { SubscriptionService } from '@usheru-hff/sdk/subscription';
import { Movie } from '@usheru-hff/shared/domain';
import { CommonModule } from '@angular/common';
import { LoadingIndicatorComponent } from '@usheru-hff/shared/ui-loading-indicator';
/**
 * Form to subscribe users to the usheru feed for this channel.
 *
 * //TODO barbeitoalex propostal - organice life cycle methods. Split in specific method to improve docs.
 * //TODO barbeitoalex propostal - subscribe to current language to update the translate pipes
 */
@Component({
  selector: 'ush-form-subscription',
  standalone: true,
  imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        LoadingIndicatorComponent,
        //RecaptchaFormsModule,
  ],
  templateUrl: './form-subscription.component.html',
  styleUrls: ['./form-subscription.component.scss']
})
export class FormSubscriptionComponent implements OnInit {
  /**
   * @docsNotRequiredd
   */
  form: FormGroup;

  @Input() movie: Movie;

  /**
   * Indicates when the user send the request (on the {@link onSubmit}) and waits for the response.
   */
  processingForm: boolean;

  /**
   * Indicates when the form was succesfully complete on the {@link onSubmit}.
   */
  sentIt: boolean;

  /**
   * Indicate that the user tried to complete the form but is not valid.
   */
  touched: boolean;

  /**
   * Message to show in the header part of the form.
   */
  @Input() formMessage?: string;

  /**
   * @deprecated Don`t found any use.
   */
  @Input() sentMessage?: string;

  /**
   * User data to send in the form.
   * //TODO barbeitoalex - why is this an input? I didn´t found any reason
   */
  @Input() consumerLead: ConsumerLead;

  /**
   * Message to show buttom the input email
   */
  @Input() buttonText?: string;

  /**
   * Event that notify when the form was completed succesfully or with fails.
   */
  @Output() formSubmitted = new EventEmitter<string>();

  constructor(
    private fb: FormBuilder,
    private translateService: TranslationsService,
    private authService: AuthService,
    private subscriptionService: SubscriptionService
  ) {}

  /**
   * Inits the form and set the initial state if get an user data from {@link AuthService}
   */
  ngOnInit() {
    this.form = this.fb.group({
      email: new FormControl('', [Validators.required, Validators.pattern(EMAIL_PATTERN)]),
      firstname: new FormControl(),
      lastname: new FormControl()
    });

    this.authService.$userStatus.subscribe(user => {
      this.updateFormData(user);
    });
  }

  /**
   * Set the form data from an user information.
   * @param user
   */
  updateFormData(user: User) {
    if (user) {
      this.form.controls.email.setValue(user.email);
      this.form.controls.firstname.setValue(user.username);
      this.form.controls.lastname.setValue('');
    }
  }

  /**
   * Submit action of the form. Check if the data is valid and makes
   * the request.
   * // barbeitoalex - why does a scroll to top in ANY case?
   */
  onSubmit() {
    if (this.form.valid) {
      if (this.consumerLead) {
        this.consumerLead.emailAddress = this.form.get('email').value;
        this.consumerLead.name = this.form.get('firstname').value;
        this.consumerLead.surname = this.form.get('lastname').value;
        this.consumerLead.language = this.translateService.language.id.toString();
      }
      this.processingForm = true;

      this.subscriptionService.putConsumerLead(this.consumerLead).subscribe(
        () => {
          this.processingForm = false;
          this.sentIt = true;
          this.formSubmitted.emit('success');
          window.scrollTo({ top: 0, behavior: 'smooth' });

          //TODO Tracking
        },
        err => {
          this.formSubmitted.emit('failed');
          console.error(err);

          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      );
    } else {
      this.touched = true;
    }
  }
}
